import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import {
  IconWrapper,
  IconBg,
  Body,
  HtmlWrapper,
  NewsletterCardContainer,
} from './style';
import routes from '../../../../routes';
import Text from '../../Text';
import Icon from '../../Icon';
import theme from '../../../theme';
import HtmlRaw from '../../HtmlRaw';
import CTA from '../../CTA';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';

const CardNewsletter = ({ mediaIsPhone, item, small }) => {
  const navigate = useNavigate();
  if (mediaIsPhone || small) {
    return (
      <NewsletterCardContainer small={small}>
        <IconWrapper
          onClick={() => {
            navigate(`${routes.newsletterDetails.path}/${item.id}`);
          }}
        >
          <IconBg small={small}>
            <Icon
              type="mail-01"
              size={small && !mediaIsPhone ? 74 : 45}
              strokeWidth={1}
              stroke={theme().colors.bgSubFooter}
              clickable={false}
            />
          </IconBg>
        </IconWrapper>
        <Body>
          <div>
            <Text
              type="h3"
              mb={8}
              onClick={() => {
                navigate(`${routes.newsletterDetails.path}/${item.id}`);
              }}
            >
              {item.title}
            </Text>
            <HtmlWrapper>
              {/* //? "subtitle" is ko and "body" can't be used, so this field will remain empty */}
              <HtmlRaw html={item.subtitle} />
            </HtmlWrapper>
          </div>
          <CTA
            type="tertiary"
            btnText="Dettaglio"
            icon="arrow-narrow-right"
            onClick={() => {
              navigate(`${routes.newsletterDetails.path}/${item.id}`);
            }}
            bottomRight
          />
        </Body>
      </NewsletterCardContainer>
    );
  }
  return (
    <NewsletterCardContainer>
      <IconBg
        onClick={() => {
          navigate(`${routes.newsletterDetails.path}/${item.id}`);
        }}
      >
        <Icon
          type="mail-01"
          size={32}
          strokeWidth={1}
          stroke={theme().colors.bgSubFooter}
          clickable={false}
        />
      </IconBg>
      <Text
        type="h3"
        onClick={() => {
          navigate(`${routes.newsletterDetails.path}/${item.id}`);
        }}
      >
        {item.title}
      </Text>
      <HtmlWrapper>
        {/* //? "subtitle" is ko and "body" can't be used, so this field will remain empty */}
        <HtmlRaw className="ellipsis" html={item.subtitle} />
      </HtmlWrapper>
      <CTA
        type="tertiary"
        btnText="Dettaglio"
        icon="arrow-narrow-right"
        onClick={() => {
          navigate(`${routes.newsletterDetails.path}/${item.id}`);
        }}
      />
    </NewsletterCardContainer>
  );
};

CardNewsletter.propTypes = {
  mediaIsPhone: PropTypes.bool,
  item: PropTypes.object,
  small: PropTypes.bool,
};

export default withMediaQueries(CardNewsletter);
